
webpack.register(
    'modules/vc-subnavigation/vc-subnavigation',
    function() {
        return import('modules/vc-subnavigation/vc-subnavigation');
    },
    true
);